<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="title-icon">view_carousel</mat-icon>
  Configuração do Carrossel
</h2>

<mat-dialog-content>
  <div class="carousel-config-container">
    <!-- Formulário de Adição/Edição -->
    <div class="form-section" fxLayout="column">
      <div class="section-header">
        <h3>{{ isEditing ? 'Editar' : 'Adicionar Nova' }} Imagem</h3>
        <div class="header-line"></div>
      </div>

      <form [formGroup]="carouselForm" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row wrap" fxLayoutGap="16px grid">
          <!-- Título e Ordem -->
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px"
            fxFlex="100">
            <mat-form-field appearance="outline" fxFlex="70" fxFlex.lt-md="100">
              <mat-label>Título</mat-label>
              <input matInput formControlName="title"
                placeholder="Digite um título">
              <mat-icon matSuffix>title</mat-icon>
              <mat-error
                *ngIf="carouselForm.get('title')?.hasError('required')">
                O título é obrigatório
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
              <mat-label>Ordem</mat-label>
              <input matInput type="number" formControlName="order" min="1"
                max="15">
              <mat-icon matSuffix>sort</mat-icon>
              <mat-hint>Ordem de exibição (1-15)</mat-hint>
              <mat-error
                *ngIf="carouselForm.get('order')?.hasError('required')">
                A ordem é obrigatória
              </mat-error>
              <mat-error
                *ngIf="carouselForm.get('order')?.hasError('min') || carouselForm.get('order')?.hasError('max')">
                A ordem deve estar entre 1 e 15
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Descrição -->
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Descrição</mat-label>
            <textarea matInput formControlName="description"
              placeholder="Digite uma descrição" rows="2"></textarea>
            <mat-icon matSuffix>description</mat-icon>
          </mat-form-field>

          <!-- Link -->
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Link (ao clicar na imagem)</mat-label>
            <input matInput formControlName="link"
              placeholder="Digite um link (opcional)">
            <mat-icon matSuffix>link</mat-icon>
          </mat-form-field>

          <!-- Status Ativo -->
          <div fxFlex="100" class="active-toggle">
            <mat-slide-toggle formControlName="isActive" color="primary">
              <div class="toggle-label">
                <mat-icon>{{ carouselForm.get('isActive')?.value ? 'visibility'
                  : 'visibility_off' }}</mat-icon>
                <span>Imagem {{ carouselForm.get('isActive')?.value ? 'Ativa' :
                  'Inativa' }}</span>
              </div>
            </mat-slide-toggle>
          </div>

          <!-- Seleção de Imagem -->
          <div fxFlex="100" class="file-upload-section">
            <div class="file-upload-container">
              <div class="upload-header">
                <span>Imagem</span>
                <div class="upload-buttons">
                  <button type="button" mat-stroked-button
                    (click)="triggerFileInput()" [disabled]="isUploading">
                    <mat-icon>{{ selectedFiles.length || imagePreview ?
                      'refresh' : 'file_upload' }}</mat-icon>
                    {{ selectedFiles.length || imagePreview ? 'Trocar Imagens'
                    : 'Selecionar Imagens' }}
                  </button>
                </div>
              </div>

              <div class="image-size-info">
                <mat-icon>info</mat-icon>
                <span>Tamanho recomendado: 1080x1080 pixels</span>
              </div>

              <input type="file" #fileInput id="imageInput"
                (change)="onFilesSelected($event)" accept="image/*" multiple
                class="file-input">

              <div class="upload-preview-container">
                <div class="image-preview"
                  *ngIf="imagePreview; else noImageTemplate">
                  <img [src]="imagePreview" alt="Preview">
                  <div class="image-preview-overlay"
                    *ngIf="selectedFiles?.length">
                    <span>{{ selectedFiles.length === 1 ? selectedFiles[0].name
                      : selectedFiles.length + ' imagens selecionadas'
                      }}</span>
                  </div>
                </div>

                <ng-template #noImageTemplate>
                  <div class="no-image-placeholder">
                    <mat-icon>image</mat-icon>
                    <span>Selecione uma imagem</span>
                  </div>
                </ng-template>
              </div>

              <mat-progress-bar *ngIf="isUploading" [value]="uploadProgress"
                mode="indeterminate" class="upload-progress"></mat-progress-bar>

              <mat-error
                *ngIf="carouselForm.get('imageUrl')?.hasError('required') && carouselForm.get('imageUrl')?.touched">
                A imagem é obrigatória
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Botões do Formulário -->
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
          class="form-actions">
          <button mat-button type="button" (click)="resetForm()"
            [disabled]="isUploading">
            <mat-icon>{{ isEditing ? 'cancel' : 'clear_all' }}</mat-icon>
            {{ isEditing ? 'Cancelar' : 'Limpar' }}
          </button>
          <button mat-raised-button color="primary" type="button"
            (click)="saveImage()"
            [disabled]="isUploading || carouselForm.invalid">
            <mat-spinner *ngIf="isUploading" diameter="20"
              class="button-spinner"></mat-spinner>
            <mat-icon *ngIf="!isUploading">{{ isEditing ? 'update' :
              'add_photo_alternate' }}</mat-icon>
            <span *ngIf="!isUploading">{{ isEditing ? 'Atualizar' : 'Adicionar'
              }}</span>
          </button>
        </div>
      </form>
    </div>

    <!-- Tabela de Imagens -->
    <div class="table-section">
      <div class="section-header">
        <h3>Imagens do Carrossel</h3>
        <div class="header-line"></div>
      </div>

      <div class="loading-indicator" *ngIf="loading">
        <mat-spinner diameter="40" color="primary"></mat-spinner>
      </div>

      <div class="table-container" *ngIf="!loading">
        <div class="paginator-info" *ngIf="totalItems > 0">
          <span>Mostrando {{ dataSource.data.length }} de {{ totalItems }}
            imagens (Página {{ currentPage + 1 }})</span>
        </div>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
          <!-- Ordem -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef>Ordem</th>
            <td mat-cell *matCellDef="let image">
              <span class="order-badge">{{ image.order }}</span>
            </td>
          </ng-container>

          <!-- Imagem -->
          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef>Imagem</th>
            <td mat-cell *matCellDef="let image">
              <div class="thumbnail-container">
                <img [src]="image.imageUrl" alt="Thumbnail" class="thumbnail">
              </div>
            </td>
          </ng-container>

          <!-- Título -->
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Título</th>
            <td mat-cell *matCellDef="let image">
              <div class="image-details">
                <span class="image-title">{{ image.title }}</span>
                <span class="image-description" *ngIf="image.description">{{
                  image.description | slice:0:50 }}{{ image.description.length >
                  50 ? '...' : '' }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="isActive">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let image">
              <div class="status-indicator">
                <mat-icon
                  [ngClass]="{'active': image.isActive, 'inactive': !image.isActive}">
                  {{ image.isActive ? 'visibility' : 'visibility_off' }}
                </mat-icon>
                <span
                  [ngClass]="{'active': image.isActive, 'inactive': !image.isActive}">
                  {{ image.isActive ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Ações -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td mat-cell *matCellDef="let image">
              <div class="action-buttons">
                <button mat-icon-button color="primary"
                  (click)="editImage(image)" matTooltip="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn"
                  (click)="deleteImage(image)" matTooltip="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [ngClass]="{'edited-row': row.id === currentImageId}"></tr>
        </table>

        <div class="paginator-container">
          <mat-paginator #paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="[6, 12, 24, 48]"
            [length]="totalItems"
            [pageIndex]="currentPage"
            showFirstLastButtons
            aria-label="Selecionar página de imagens">
          </mat-paginator>
        </div>

        <div class="no-data-message"
          *ngIf="!loading && dataSource.data.length === 0">
          <mat-icon>photo_library</mat-icon>
          <p>Nenhuma imagem cadastrada. Adicione a primeira imagem para o
            carrossel.</p>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fechar</button>
</mat-dialog-actions>